import React from 'react';
import { FadeIn } from './ui/FadeIn';
const chatImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/t9PcyGJtSTnjb3jjo8Jm7P/caht_4.png',
  alt: 'Testimonio de Camila Serna — dormí 7 horas seguidas por primera vez'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/icDhgF2R6b69Took7MNPbN/chat_2.png',
  alt: 'Testimonio de Susu Hidalgo — por fin puedo desconectarme del trabajo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qo7LRYrD2Up7Vue5pVQYea/chat_5.png',
  alt: 'Testimonio de Miriam Jara — por fin podía relajarme después del trabajo'
}];
export function Testimonials() {
  return <section className="px-6 py-5 max-w-3xl mx-auto" data-id="element-461">
      <FadeIn data-id="element-462">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4A5D3A] text-center mb-3" data-id="element-463">
          Mujeres que ya lograron apagar el ruido mental por la noche
        </h2>
        <p className="text-center text-[#2D2A26]/60 mb-10 text-lg" data-id="element-464">
          Conversaciones reales. Sin editar.
        </p>
      </FadeIn>

      <div className="space-y-8" data-id="element-465">
        {chatImages.map((chat, i) => <FadeIn key={i} delay={i * 0.12} data-id="element-466">
            <img src={chat.src} alt={chat.alt} className="w-full max-w-md mx-auto rounded-2xl shadow-lg" data-id="element-467" />
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} data-id="element-468">
        <div className="text-center mt-10" data-id="element-469">
          <a href="https://pay.hotmart.com/Y104754180A?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-block w-full max-w-md mx-auto text-center bg-[#4A5D3A] text-[#FAF6F0] font-bold py-5 px-8 rounded-xl shadow-lg hover:bg-[#3a4a2e] transition-colors text-lg md:text-xl" data-id="element-470">
            SÍ — QUIERO APAGAR EL RUIDO MENTAL ESTA NOCHE → $6.39 USD
          </a>

          <div className="flex flex-wrap justify-center gap-4 mt-4 text-sm text-[#2D2A26]/60" data-id="element-471">
            <span data-id="element-472">🔒 Pago seguro</span>
            <span data-id="element-473">⚡ Acceso inmediato</span>
            <span data-id="element-474">🌿 Ingredientes fáciles de conseguir</span>
          </div>
        </div>
      </FadeIn>
    </section>;
}